import { useMemo } from "react"

import { selectOnboardingStep, useDappSelector } from "#/redux-state"
import { OnboardingStep } from "#/shared/types"

import OnboardingModalAccountCreated from "./OnboardingModalAccountCreated"
import OnboardingModalAccountNotFound from "./OnboardingModalAccountNotFound"
import OnboardingModalAuthentication from "./OnboardingModalAuthentication"
import OnboardingModalCreateAccount from "./OnboardingModalCreateAccount"
import OnboardingModalLoadingScreen from "./OnboardingModalLoadingScreen"

type OnboardingModalBodyProps = {
  closeModal: () => void
}

export default function OnboardingModalBody({
  closeModal,
}: OnboardingModalBodyProps) {
  const onboardingStep = useDappSelector(selectOnboardingStep)

  const onboardingModalSteps = useMemo(
    () => ({
      // Account succesfully created screen
      [OnboardingStep.ACCOUNT_CREATED]: (
        <OnboardingModalAccountCreated closeModal={closeModal} />
      ),
      // Loading screen when account creation is in progress
      [OnboardingStep.ACCOUNT_CREATION_IN_PROGRESS]: (
        <OnboardingModalLoadingScreen label="Creating account..." />
      ),
      // Loading screen when claiming rewards is in progress
      [OnboardingStep.CLAIMING_REWARDS_IN_PROGRESS]: (
        <OnboardingModalLoadingScreen label="Claiming rewards..." />
      ),
      // Onboarding modal screen for not found account error
      [OnboardingStep.ACCOUNT_NOT_FOUND]: (
        <OnboardingModalAccountNotFound closeModal={closeModal} />
      ),
      // Onboarding modal create account screen
      [OnboardingStep.CREATE_ACCOUNT]: <OnboardingModalCreateAccount />,
      // Onboarding modal initial screen
      [OnboardingStep.AUTHORIZATION]: <OnboardingModalAuthentication />,
    }),
    [closeModal],
  )

  return onboardingModalSteps[onboardingStep] || null
}
